import fs from 'node:fs'
import path from 'node:path'
import { getAllTrackedFilePaths } from '@core-engine/snapshots/store/get-all-tracked-file-paths.js'

export function getExistingTrackedFilePaths(cwd: string): string[] {
  return getAllTrackedFilePaths(cwd).filter((filePath) =>
    fs.existsSync(path.join(cwd, ...filePath.split('/')))
  )
}
